module.exports = __webpack_public_path__ + "static/media/i5.36204ea3.png";